// Images
import uxInterface from '../images/card-logos/ux-interface.webp';
import backend from '../images/card-logos/backend.webp';

const cards = [
	{
		id: 0,
		src: uxInterface,
		title: 'Frontend Developer',
		text: 'I find it easy to develop from a sketch to the final product in order to bring the ideas to the browser.',
		languages: 'HTML, CSS, Sass, Javascript, Typescript',
		tools: [
			{ id: 1, name: 'React', link: 'https://reactjs.org/' },
			{ id: 2, name: 'Angular', link: 'https://angular.io/' },
			{ id: 3, name: 'Vue', link: 'https://vuejs.org/' },
			{ id: 4, name: 'Bootstrap', link: 'https://getbootstrap.com/' },
			{ id: 5, name: 'Bulma', link: 'https://bulma.io/' },
			{ id: 6, name: 'Figma', link: 'https://www.figma.com/' },
		],
	},
	{
		id: 1,
		src: backend,
		title: 'Backend Developer',
		text: "Being able to create the structure and mechanism of an application fascinates me. It's a lot of work to create and test all the necessary integrations, but I like it.",
		languages: 'Java, Python, PHP, Javascript, SQL, MongoDB, NodeJs',
		tools: [
			{
				id: 0,
				name: 'Spring Boot',
				link: 'https://spring.io/projects/spring-boot',
			},
			{
				id: 1,
				name: 'MongoDB',
				link: 'https://www.mongodb.com/cloud/atlas',
			},
			{
				id: 2,
				name: 'MySQL',
				link: 'https://www.mysql.com/',
			},
			{
				id: 3,
				name: 'PostgreSQL',
				link: 'https://www.postgresql.org/',
			},
			{
				id: 4,
				name: 'Google Firebase',
				link: 'https://firebase.google.com/',
			},
			{
				id: 5,
				name: 'NodeJS',
				link: 'https://nodejs.org/en/',
			},
		],
	},
];

export default cards;